import React, { Component } from 'react'

export default class NotFoundPage extends Component {
  render() {
    return (
      <div>
        NOT FOUND
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/frontend/base/components/NotFoundPage.js